<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">配餐计划修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="配餐计划时间" required prop="time">
                                    <el-date-picker
                                        v-model="editForm.time"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期"
                                        disabled
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="早餐配餐"  required prop="morningPlan">
                                    <el-select
                                        v-model="editForm.morningPlan"
                                        multiple
                                        style="width:100%"
                                        filterable
                                        placeholder="请选择菜品">
                                        <el-option
                                            v-for="item in dishesList"
                                            :key="item.dishesCode"
                                            :label="item.name"
                                            :value="item.dishesCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            
                            <el-col :span="12" class="item">
                                <el-form-item label="午餐配餐" required prop="noonPlan">
                                    <el-select
                                        v-model="editForm.noonPlan"
                                        multiple
                                        filterable
                                        style="width:100%"
                                        placeholder="请选择菜品">
                                        <el-option
                                            v-for="item in dishesList"
                                            :key="item.dishesCode"
                                            :label="item.name"
                                            :value="item.dishesCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="晚餐配餐" required prop="nightPlan">
                                    <el-select
                                        v-model="editForm.nightPlan"
                                        multiple
                                        filterable
                                        style="width:100%"
                                        placeholder="请选择菜品">
                                        <el-option
                                            v-for="item in dishesList"
                                            :key="item.dishesCode"
                                            :label="item.name"
                                            :value="item.dishesCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item" v-if="isRemarks()">
                                <el-form-item label="备注" required prop="remarks">
                                    <el-input v-model="editForm.remarks" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                                </el-form-item> 
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['dishesList'],
        data() {
            return {
                loading: false,
                floor:null,
                morningPlan:[],
                noonPlan:[],
                nightPlan:[],
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    time:'',
                    status:0,
                    dishesPlanCode:'',
                    morningPlan:[],
                    noonPlan:[],
                    nightPlan:[],
                    dishesPlan:{
                        morningPlan:[],
                        noonPlan:[],
                        nightPlan:[]
                    },
                    remarks:null
                },
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    },
                },
                rules:{
                    time:[
                        { required: true, message: '请选择时间', trigger: 'blur' },
                    ],
                    morningPlan:[
                        { required: true, message: '请选择早餐菜品', trigger: 'blur' },
                    ],
                    noonPlan:[
                        { required: true, message: '请选择午餐菜品', trigger: 'blur' },
                    ],
                    nightPlan:[
                        { required: true, message: '请选择晚餐菜品', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请填写备注', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(row){
                this.loading=false
                this.editForm.time = row.time;
                this.editForm.dishesPlanCode = row.dishesPlanCode;
                this.editForm.remarks = null;
                this.editForm.morningPlan = this.getDishCode(row.dishesPlanMorning.listDishesPlanMorningItem);
                this.editForm.noonPlan = this.getDishCode(row.dishesPlanNoon.listDishesPlanNoonItem);
                this.editForm.nightPlan = this.getDishCode(row.dishesPlanNight.listDishesPlanNightItem);
            },
            isRemarks(){
                if(!this.editForm.time){
                    return false
                }
                var time=timefilters(this.editForm.time).slice(0,10)
                var nowTime=timefilters(new Date()).slice(0,10)
                if(time==nowTime){
                    return true
                }
                return false
            },
            getDishCode(list){
                var list1=[]
                for(var i in list){
                    list1.push(list[i].dishesCode)
                }
                return list1
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        if(this.editForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.dishesPlan.morningPlan=this.editForm.morningPlan
                this.editForm.dishesPlan.noonPlan=this.editForm.noonPlan
                this.editForm.dishesPlan.nightPlan=this.editForm.nightPlan
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DishesPlan/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                            this.editForm.morningPlan=null
                            this.editForm.noonPlan=null
                            this.editForm.nightPlan=null
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width:700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .box-card{
                margin: 10px 0;
            }
            .dishesPlanAdd{
                float: right;transform: translate(0px, -9px);
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
